import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-info",
  "use": "icon-info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol role=\"img\" aria-label=\"Description of your SVG image\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-info\">\r\n  <title>info</title>\r\n  <path d=\"M8,14A6,6,0,1,0,2,8,6,6,0,0,0,8,14Zm0,2a8,8,0,1,1,8-8A8,8,0,0,1,8,16ZM7,9.15V8.95a1.31,1.31,0,0,1,.54-1.1c.35-.3.93-.59.93-1a.46.46,0,0,0-.51-.45c-.32,0-.64.16-.64.46V7H5.71V6.76C5.71,5.55,6.86,5,8,5c1.4,0,2.17.66,2.17,1.75a1.66,1.66,0,0,1-.81,1.43c-.28.19-.79.37-.79.76v.22Zm-.1,2.08V9.56H8.64v1.67Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/info.svg
// module id = 290
// module chunks = 0 1